module.exports = __webpack_public_path__ + "img/black-card-no-logo.d70767ad.png";